import { GeoPediaDTO } from './GeoPediaDTO';
import { FormBuilder, Validators } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';

export enum RegionMapTypes {
    ZIP_GLOBAL = 'ZipGlobal',
    GEOPEDIA = 'GeoPedia',
    ADDRESS = 'Address',
    LATLONG = 'LatLong',
    ZIP_PLUS_4 = 'ZipPlus4'
}

export class GeoTargetingDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        {
            name: 'type',
            type: RegionMapTypes,
            defaultValue: RegionMapTypes.GEOPEDIA
        },
        {
            name: 'regionValues',
            type: 'formGroup',
            arrayClass: GeoPediaDTO,
            createInitialItem: true
        },
        {
            name: 'targetedRegions',
            type: 'any[]',
            defaultValue: [
                {
                    id: 2,
                    name: 'United States',
                    type: 'Country',
                    fullyQualifiedName: 'North America > United States',
                    fullyQualifiedValue: {
                        continent: 'North America',
                        country: 'United States',
                        region: null,
                        city: null,
                        dma: null
                    }
                }
            ],
            includeInSaveDTO: true,
            validators: [Validators.required]
        }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
